__turbopack_context__.v({
  "button": "apply-module__HI3XOW__button",
  "buttonIcon": "apply-module__HI3XOW__buttonIcon",
  "container": "apply-module__HI3XOW__container",
  "countdownButton": "apply-module__HI3XOW__countdownButton",
  "desktopContent": "apply-module__HI3XOW__desktopContent",
  "desktopText": "apply-module__HI3XOW__desktopText",
  "fadeInItems": "apply-module__HI3XOW__fadeInItems",
  "image": "apply-module__HI3XOW__image",
  "imageContent": "apply-module__HI3XOW__imageContent",
  "imageWrapper": "apply-module__HI3XOW__imageWrapper",
  "mainContent": "apply-module__HI3XOW__mainContent",
  "spacing--lg": "apply-module__HI3XOW__spacing--lg",
  "spacing--md": "apply-module__HI3XOW__spacing--md",
  "spacing--sm": "apply-module__HI3XOW__spacing--sm",
  "spacing--xl": "apply-module__HI3XOW__spacing--xl",
  "spacing--xs": "apply-module__HI3XOW__spacing--xs",
  "spacing--xxl": "apply-module__HI3XOW__spacing--xxl",
  "spacing--xxs": "apply-module__HI3XOW__spacing--xxs",
  "spacing--xxxl": "apply-module__HI3XOW__spacing--xxxl",
  "spacing--xxxs": "apply-module__HI3XOW__spacing--xxxs",
  "title": "apply-module__HI3XOW__title",
});
